import React from "react";
import moment from "moment";

import { fetchApi } from "../../Network/NetworkService";
import { notif } from "../Ui/Notification";

import "../../Assets/Pages/dermatoSdr.css";
import IconTooltip from "../Ui/IconTooltip";

// Libellés FR des états de consultation (request.model state enum, hors
// "incomplete" qui est exclu par définition de cette liste).
const STATE_LABELS = {
  waiting: "En attente",
  approved: "Approuvée",
  toCall: "À appeler",
  reviewed: "Examinée",
  canceled: "Annulée",
  refunded: "Remboursée",
  terminated: "Terminée",
};

// Réactivations RGPD : patients ayant reçu le mail de campagne puis refait une
// vraie consultation après. Alimenté par GET /gdpr-warning/reactivations.
class GdprReactivation extends React.Component {
  constructor() {
    super();
    this.state = {
      rows: [],
      stats: null,
      loading: false,
      loaded: false,
      page: 1,
      totalPage: 0,
      countItems: 0,
    };
  }

  componentDidMount() {
    this.fetchRows();
  }

  fetchRows = () => {
    this.setState({ loading: true });
    fetchApi("/gdpr-warning/reactivations?page=" + this.state.page)
      .then((res) => {
        this.setState({
          rows: res.reactivations || [],
          stats: res.stats || null,
          totalPage: res.countPages || 0,
          countItems: res.countItems || 0,
          loaded: true,
          loading: false,
        });
      })
      .catch(() => {
        notif.addNotification(
          "Erreur",
          "Erreur de récupération des réactivations",
          "warning",
        );
        this.setState({ loading: false });
      });
  };

  updatePage(page) {
    this.setState({ rows: [], page, loading: true }, this.fetchRows);
  }

  render() {
    const { rows, stats, loading, loaded, page, totalPage, countItems } =
      this.state;

    return (
      <div className="dermato-sdr-container">
        <div className="dermato-sdr-header">
          <h2 className="dermato-sdr-title">
            {"RGPD — Réactivations (consultation après le mail)"}
          </h2>
          <button
            className="dermato-sdr-btn dermatosdr-btn-link"
            onClick={() => this.props.history.push("/gdpr-warning")}
          >
            {"← Retour aux envois"}
          </button>
        </div>

        <div className="dermato-sdr-card">
          <h3 className="dermato-sdr-card-title">
            {"Patients réactivés"} ({countItems})
          </h3>
          <p style={{ margin: "0 0 16px", color: "#888", fontSize: 14 }}>
            {
              "Patients ayant reçu le mail de la campagne RGPD puis créé une vraie consultation (hors demandes incomplètes) après l'avoir reçu."
            }
          </p>

          {stats && stats.total > 0 && (
            <div className="gdpr-stats">
              <div className="gdpr-stat gdpr-stat-primary">
                <div className="gdpr-stat-value">{stats.total}</div>
                <span className="gdpr-stat-label">{"Patients réactivés"}</span>
              </div>
              <div className="gdpr-stat">
                <div className="gdpr-stat-value">{stats.noRequest}</div>
                <span className="gdpr-stat-label">{"Sans requête"}</span>
              </div>
              <div className="gdpr-stat">
                <div className="gdpr-stat-value">{stats.incomplete}</div>
                <span className="gdpr-stat-label">{"Incomplets"}</span>
              </div>
              <div className="gdpr-stat">
                <div className="gdpr-stat-value">{stats.totalConsults}</div>
                <span className="gdpr-stat-label">
                  {"Consultations de retour"}
                </span>
              </div>
              <div className="gdpr-stat">
                <div className="gdpr-stat-value">
                  {Math.round(stats.avgDelayDays || 0)}
                  <span className="gdpr-stat-suffix">{"j"}</span>
                </div>
                <span className="gdpr-stat-label">{"Délai moyen"}</span>
              </div>
            </div>
          )}

          {loading ? (
            <div className="dermato-sdr-empty">
              <span className="loader" />
            </div>
          ) : loaded && rows.length === 0 ? (
            <div className="dermato-sdr-empty">
              {"Aucune réactivation pour l'instant."}
            </div>
          ) : rows.length > 0 ? (
            <div>
              <table className="dermato-sdr-table">
                <thead>
                  <tr>
                    <th>Patient</th>
                    <th>Email</th>
                    <th>Population</th>
                    <th>{"Mail reçu le"}</th>
                    <th>{"Consultation le"}</th>
                    <th>{"Délai"}</th>
                    <th>{"Consultations"}</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((r) => (
                    <tr key={r._id}>
                      <td>
                        {r.FName} {r.LName}
                      </td>
                      <td>{r.email}</td>
                      <td>
                        <span
                          className={
                            "dermato-sdr-badge " +
                            (r.population === "noRequest"
                              ? "dermato-sdr-badge-relance"
                              : "dermato-sdr-badge-send")
                          }
                        >
                          {r.population === "noRequest"
                            ? "Sans requête"
                            : "Incomplets"}
                        </span>
                      </td>
                      <td>
                        {r.mailSentAt
                          ? moment(r.mailSentAt).format("DD/MM/YYYY HH:mm")
                          : "—"}
                      </td>
                      <td>
                        {r.firstReturnAt
                          ? moment(r.firstReturnAt).format("DD/MM/YYYY HH:mm")
                          : "—"}
                        {r.returnState || r.returnType ? (
                          <span
                            style={{
                              display: "block",
                              color: "#888",
                              fontSize: 12,
                            }}
                          >
                            {[
                              r.returnType,
                              STATE_LABELS[r.returnState] || r.returnState,
                            ]
                              .filter(Boolean)
                              .join(" · ")}
                          </span>
                        ) : null}
                      </td>
                      <td>
                        {typeof r.delayDays === "number"
                          ? r.delayDays <= 0
                            ? "le jour même"
                            : r.delayDays + " j"
                          : "—"}
                      </td>
                      <td style={{ color: "#2e7d32", fontWeight: 600 }}>
                        {r.returnCount}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="dermatosdr-pagination">
                <p style={{ margin: 0, color: "#888", fontSize: 14 }}>
                  Page <strong>{page}</strong> / {totalPage}
                </p>
                <div>
                  {page > 1 && (
                    <IconTooltip
                      icon="fa fa-chevron-left"
                      text="Page précédente"
                      onClick={() => this.updatePage(page - 1)}
                    />
                  )}
                  {page < totalPage && (
                    <IconTooltip
                      icon="fa fa-chevron-right"
                      text="Page suivante"
                      onClick={() => this.updatePage(page + 1)}
                    />
                  )}
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default GdprReactivation;
